// Import Swiper and its styles
import Swiper from "swiper/bundle";
import { wait } from "./../../helpers/global";

export default class CarouselImg {
	constructor() {
		// Wrapper around linked (controller) pairs of swiper instances
		this.carouselWrappers = document.querySelectorAll(".jsCarouselImgWrapper");

		if (this.carouselWrappers) this.init();
	}

	setCarousel(wrapper) {
		this.carouselContent = wrapper.querySelector(".jsCarouselImgContent");
		this.carouselPagination = wrapper.querySelector(".jsCarouselImgPagination");
		this.carouselImg = wrapper.querySelector(".jsCarouselImg");

		// helpers
		this._content = {};
		this._img = {};

		this._contentConfig = {
			autoHeight: true,
			speed: 700,
			spaceBetween: 30,
			pagination: {
				el: this.carouselPagination,
				clickable: true,
				renderBullet: (index, className) =>
					'<span class="carousel-bullet__item ' + className + '"></span>'
			},
		};

		this._imgConfig = {
			autoplay: {
				delay: 7000,
			},
			speed: 700,
			effect: "fade",
			fadeEffect: {
				crossFade: true
			},
			preloadImages: true,
			updateOnImagesReady: true,
			pagination: {
				el: this.carouselPagination,
				clickable: true,
				renderBullet: (index, className) =>
					'<span class="carousel-bullet__item ' + className + '"></span>'
			}
		};

		this._img = new Swiper(this.carouselImg, this._imgConfig);
		this._content = new Swiper(this.carouselContent, this._contentConfig);

		this._content.controller.control = this._img;
		this._img.controller.control = this._content;
	}

	init() {
		this.carouselWrappers.forEach(wrapper => {
			this.setCarousel(wrapper);
		});
	}
}